import PropTypes from "prop-types"

const SelectionTypeErrors = ({ errors }) => {
  return (
    <div id="error_explanation" className="error-alert alert">
      <h3>Uh oh! Looks like there were some problems:</h3>
      <ul>
        {errors.map((error, index) => (
          <li key={index}>{error}</li>
        ))}
      </ul>
    </div>
  )
}

SelectionTypeErrors.propTypes = {
  errors: PropTypes.array
}

export default SelectionTypeErrors
